import { Dropdown, Modal, Col, Row, Space, Typography, message } from "antd";
import ConsultantsView from "../components/ConsultantsView";
import { useState } from "react";
import ConsultantView from "../components/ConsultantView";
import { Guid } from "guid-typescript";
import { SearchQuery } from "../code/search-query/search-query";
import { getConsultantsExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import { Consultant } from "../repository/data.default";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { getProblemMessage } from "../utils/http";

function ConsultantsPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [consultantInputMode, setConsultantInputMode] = useState<
    "add" | "view" | "delete"
  >("add");
  const [consultantInputUid, setConsultantInputUid] = useState<
    string | null | undefined
  >({} as any);
  const [consultantInputOpen, setConsultantInputOpen] = useState(false);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const [consultantInputValues, setConsultantInputValues] =
    useState<Consultant>({} as any);
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onConsultantAction(
    mode: "add" | "view" | "delete",
    values?: Consultant,
  ): void {
    setConsultantInputMode(mode);
    setConsultantInputOpen(true);
    setConsultantInputUid(values?.uid);
  }

  function onConsultantFinish(): void {
    setConsultantInputOpen(false);
    setConsultantInputValues({} as any);
    setTriggerView(Guid.create().toString());
  }

  function onConsultantClose(): void {
    setConsultantInputOpen(false);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading Consultants export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getConsultantsExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Consultants
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("PlatformConsultants", "create")}

            className={`${!permissions.can("PlatformConsultants", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("PlatformConsultants", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onConsultantAction("add")}
          >
            Add Consultant
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <ConsultantsView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onConsultantAction(key as any, record)
          }
          onSearch={onSearch}
        />
      </Col>
      <ConsultantView
        open={consultantInputOpen}
        mode={consultantInputMode}
        uid={consultantInputUid!}
        initialValues={consultantInputValues}
        onFinish={onConsultantFinish}
        onClose={onConsultantClose}
      />
      {contextHolder}
    </Col>
  );
}

export default ConsultantsPage;
